import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import clsx from 'clsx';
import Container from '@/components/Container';
import Lead from '@/components/Lead';
import Link from '@/components/Link';
import BasicLayout from './BasicLayout';

function LegalNavigationLink({ href, isActive, children }) {
  return (
    <Link
      href={href}
      className={clsx(
        'inline-flex py-2',
        isActive === true && 'pointer-events-none font-medium text-gray-900',
        isActive === false &&
          'text-gray-500 hover:text-gray-900 transition ease-in-out duration-300'
      )}
    >
      {children}
    </Link>
  );
}

const defaultProps = {};

const propTypes = {
  pageTitle: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default function LegalLayout({ pageTitle, children }) {
  const router = useRouter();

  return (
    <BasicLayout>
      <div className="bg-gradient-to-tl from-green-100 to-green-50 py-10 lg:py-20">
        <Container>
          <div className="flex flex-col items-center text-center space-y-4">
            <h1 className="text-xl lg:text-5xl font-semibold tracking-tight">
              Políticas y procedimientos
            </h1>
            <Container maxWidth="max-w-screen-lg" className="lg:px-24">
              <Lead>
                Nos comprometemos a mantener la seguridad de sus datos, la
                privacidad de su información privada y a ser transparentes sobre
                nuestras prácticas como empresa.
              </Lead>
            </Container>
          </div>
        </Container>
      </div>
      <div className="py-10 lg:pb-20 bg-gradient-to-t from-gray-100 to-white">
        <Container>
          <div className="grid grid-cols-1 lg:grid-cols-12">
            <div className="lg:col-span-3">
              <div className="relative lg:sticky lg:top-32 z-10">
                <nav className="flex flex-col space-y-1 text-lg lg:py-10">
                  <LegalNavigationLink
                    href="/legal/tos"
                    isActive={router.pathname === '/legal/tos'}
                  >
                    Términos de servicio
                  </LegalNavigationLink>
                  <LegalNavigationLink
                    href="/legal/privacidad"
                    isActive={router.pathname === '/legal/privacidad'}
                  >
                    Política de privacidad
                  </LegalNavigationLink>
                  <LegalNavigationLink
                    href="/legal/cookies"
                    isActive={router.pathname === '/legal/cookies'}
                  >
                    Política de cookies
                  </LegalNavigationLink>
                </nav>
              </div>
            </div>
            <div className="lg:col-span-9 pt-10 divide-y">
              <h2 className="text-xl lg:text-4xl font-semibold tracking-tight pb-10">
                {pageTitle}
              </h2>
              <div className="prose lg:prose-lg font-normal">{children}</div>
            </div>
          </div>
        </Container>
      </div>
    </BasicLayout>
  );
}

LegalLayout.defaultProps = defaultProps;
LegalLayout.propTypes = propTypes;
